import { History } from 'history'

export const redirectUrl = (history: History, url: string): void => {
  const splitUrl = url.split('/')
  splitUrl.pop()
  const redirectionPath = splitUrl.join('/')
  history.push(redirectionPath)
}
